var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.cssVars),attrs:{"id":"app"},on:{"gesturestart":_vm.handleGestureStart,"gesturechange":_vm.handleGestureChange}},[_c('router-view'),_c('Alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }